import React from 'react';
import { Link } from 'react-router-dom';

function MobileMenu({ onClose }) {
  return (
    <div className="menu-modal" style={{
      position: 'fixed', inset: 0,
      background: 'rgba(0,0,0,0.95)',
      zIndex: 1000,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center'
    }}>
      <button onClick={onClose} style={{
        position: 'absolute', top: 20, right: 20,
        background: 'none', border: 'none',
        color: '#fff', fontSize: 28, cursor: 'pointer'
      }}>
        <i className="fas fa-times"></i>
      </button>
      <nav style={{ textAlign: 'center' }}>
        <Link to="/" onClick={onClose} style={{ display: 'block', color: '#fff', fontSize: 24, padding: 15, textDecoration: 'none' }}>Accueil</Link>
        <Link to="/presentation" onClick={onClose} style={{ display: 'block', color: '#fff', fontSize: 24, padding: 15, textDecoration: 'none' }}>Présentation</Link>
        <Link to="/prestations" onClick={onClose} style={{ display: 'block', color: '#fff', fontSize: 24, padding: 15, textDecoration: 'none' }}>Prestations</Link>
        <Link to="/projets" onClick={onClose} style={{ display: 'block', color: '#fff', fontSize: 24, padding: 15, textDecoration: 'none' }}>Vos Projets</Link>
        <Link to="/bim" onClick={onClose} style={{ display: 'block', color: '#fff', fontSize: 24, padding: 15, textDecoration: 'none' }}>BIM</Link>
        <Link to="/contact" onClick={onClose} style={{ display: 'block', color: '#fff', fontSize: 24, padding: 15, textDecoration: 'none' }}>Contact</Link>
      </nav>
    </div>
  );
}

export default MobileMenu;
